import { useEffect, useRef } from 'react';
import { rage, useObservable } from '~/rage';
import { StyledEmptyContainer } from './ClipboardCopy.styled';

const ClipboardCopy: React.FC = () => {
	const containerRef = useRef<HTMLDivElement>(null);
	const clipboardText = useObservable(rage.input.getClipboardText());

	useEffect(() => {
		if (!containerRef.current) {
			return;
		}

		if (!clipboardText || clipboardText.length === 0) {
			return;
		}

		const textField = document.createElement('textarea');
		textField.value = clipboardText;
		containerRef.current.appendChild(textField);

		textField.select();
		document.execCommand('copy');

		textField.remove();

		// Reset state
		rage.input.copyToClipboard(null);
	}, [clipboardText]);

	return <StyledEmptyContainer ref={containerRef} />;
};

export { ClipboardCopy };
